import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import get from 'lodash/get';
import moment from 'moment';

import Content from '../components/MainContent';
import Button from '../../../../components/Button';
import DatepickerRange from '../../components/DatepickerRange';
import { getQuery } from '../../../pages/Paspor/function';

import {
  getInvestmentQuestionList,
  getTradeQuestionList,
  getStatistic,
  getStatisticWeek,
  getStatisticMonth
} from './action';
import { getStatisticDate, downloadFile } from '../../functions';

const MenghubungkanIndonesia = ({
  getInvestmentQuestionList,
  getTradeQuestionList,
  investmentList,
  tradeList,
  statistic,
  statisticWeek,
  statisticMonth,
  getStatistic,
  getStatisticWeek,
  getStatisticMonth,
  history
}) => {
  const title = 'EKONOMI - Berbisnis di Wilayah Kerja KJRI New York';
  const { tab = 1 } = getQuery(history);

  const date = new Date();
  const last = new Date();
  const [startDate, setStartDate] = useState(date);
  const [endDate, setEndDate] = useState(last);

  const [activeTab, setActiveTab] = useState(String(tab));
  const [page, setPage] = useState(1);
  const [query, setQuery] = useState();
  const [pageDivider, setPageDivider] = useState(5);

  const tabList = {
    '1': 'investment',
    '2': 'trade'
  };

  const activeData = activeTab === '1' ? investmentList : tradeList;
  const listData = get(activeData, ['data', 'data', 'data']) || [];
  const pagination = get(activeData, ['data', 'pagination']) || [];
  const loading = get(activeData, ['status']) === 'pending';

  const getSummaryData = () => {
    const summaryData = [
      {
        title: 'Data Hari Ini',
        subtitle: title,
        numOfIn: String(0)
      },
      {
        title: 'Data Minggu Ini',
        subtitle: title,
        numOfIn: String(0)
      },
      {
        title: 'Data Bulan Ini',
        subtitle: title,
        numOfIn: String(0)
      }
    ];
    const dayStatistic = get(statistic, ['data']) || [];
    const weekStatistic = get(statisticWeek, ['data']) || [];
    const monthStatistic = get(statisticMonth, ['data']) || [];

    const setTotal = (statistic, index) => {
      statistic.map(({ status, total }) => {
        switch (status) {
          case null:
            summaryData[index].numOfIn = String(total);
            break;
        }
      });
    };

    setTotal(dayStatistic, 0);
    setTotal(weekStatistic, 1);
    setTotal(monthStatistic, 2);

    return summaryData;
  };
  const summaryData = getSummaryData();

  const loadData = (type) => {
    const params = {
      per_page: pageDivider,
      page: page,
      from: moment(startDate).format('YYYY-MM-DD'),
      to: moment(endDate).format('YYYY-MM-DD')
    };

    if (query && query !== '') {
      params.q = query;
      params.page = undefined;
    }

    if (type === 'trade') {
      getTradeQuestionList(params);
    } else if (type === 'investment') {
      getInvestmentQuestionList(params);
    }
  };

  const loadStatisticData = (type) => {
    const { today, startWeek, endWeek, startMonth, endMonth } = getStatisticDate();
    getStatistic(
      {
        from: today,
        to: today
      },
      type
    );
    getStatisticWeek(
      {
        from: startWeek,
        to: endWeek
      },
      type
    );
    getStatisticMonth(
      {
        from: startMonth,
        to: endMonth
      },
      type
    );
  };

  const handlerDownload = () => {
    const params = {
      from: moment(startDate).format('YYYY-MM-DD'),
      to: moment(endDate).format('YYYY-MM-DD')
    };
    const fileName = `${title}-${params.from}-${params.to}`;
    downloadFile(`${tabList[activeTab]}/question`, params, fileName);
  };

  useEffect(() => {
    loadData(tabList[activeTab]);
    loadStatisticData(tabList[activeTab]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTab, pageDivider, page, query]);

  return (
    <div className='admin-visa'>
      <Content
        title={title}
        dataTab={listData}
        summaryData={summaryData}
        onTabChanges={setActiveTab}
        onPageChanges={setPage}
        onQueryChanges={setQuery}
        onPageDividerChanges={setPageDivider}
        defaultActiveTab={activeTab}
        pagination={pagination}
        typeTab={tabList[activeTab]}
        type='ekohubung'
        loading={loading}
        topActionComponent={
          <div className='detail-action' style={{ display: 'flex' }}>
            <DatepickerRange
              startDate={startDate}
              setStartDate={setStartDate}
              endDate={endDate}
              setEndDate={setEndDate}
              onCalendarClose={() => loadData(tabList[activeTab])}
            />
            <Button color='info' onClick={handlerDownload} style={{ marginLeft: '16px' }}>
              Download
            </Button>
          </div>
        }
      />
    </div>
  );
};

MenghubungkanIndonesia.propTypes = {
  getInvestmentQuestionList: PropTypes.func,
  getTradeQuestionList: PropTypes.func,
  investmentList: PropTypes.object,
  tradeList: PropTypes.object,
  statistic: PropTypes.object,
  statisticWeek: PropTypes.object,
  statisticMonth: PropTypes.object,
  getStatistic: PropTypes.func,
  getStatisticWeek: PropTypes.func,
  getStatisticMonth: PropTypes.func
};

const mapStateToProps = (state) => ({
  investmentList: {
    status: state.getInvestmentQuestionListReducer.status,
    error: state.getInvestmentQuestionListReducer.error,
    data: state.getInvestmentQuestionListReducer.data
  },
  tradeList: {
    status: state.getTradeQuestionListReducer.status,
    error: state.getTradeQuestionListReducer.error,
    data: state.getTradeQuestionListReducer.data
  },
  statistic: {
    status: state.getHubIndoStatisticReducer.status,
    error: state.getHubIndoStatisticReducer.error,
    data: state.getHubIndoStatisticReducer.data
  },
  statisticWeek: {
    status: state.getHubIndoStatisticWeekReducer.status,
    error: state.getHubIndoStatisticWeekReducer.error,
    data: state.getHubIndoStatisticWeekReducer.data
  },
  statisticMonth: {
    status: state.getHubIndoStatisticMonthReducer.status,
    error: state.getHubIndoStatisticMonthReducer.error,
    data: state.getHubIndoStatisticMonthReducer.data
  }
});

export default compose(
  connect(mapStateToProps, {
    getInvestmentQuestionList,
    getTradeQuestionList,
    getStatistic,
    getStatisticWeek,
    getStatisticMonth
  }),
  withRouter
)(MenghubungkanIndonesia);
